import { useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import { getDatesForWeek, getIsPerDiemByDate } from '../../pages/timesheet/helpers';
import ExpandedPanel from '../ExpandedPanel/ExpandedPanel';
import classes from './PerDiemCreationComponent.module.scss';
import OutlinedCheckBox from '../Form/OutlinedCheckBox/OutlinedCheckBox';
import { submissionEnum } from '../../../utils/enums';

const PerDiemCreationComponent = ({
  startDateOfPeriod,
  perdiems,
  changePerdiem,
  setScrollablePerDiem = () => {},
  choosedMonth,
  timesheetType,
  fullDisabled,
  extraClass
}) => {
  const { t } = useTranslation();
  const refPerDiem = useRef(null);

  const datesForWeek = getDatesForWeek(startDateOfPeriod);

  useEffect(() => {
    setScrollablePerDiem(refPerDiem);
  }, [refPerDiem]);

  return (
    <ExpandedPanel title={t('dashboard.timesheet.perdiem')} isExpanded={perdiems.some((item) => item.IsPerDiem)}>
      {timesheetType === submissionEnum.WEEKLY ? (
        <div className={extraClass || classes.perdiemsContainer}>
          {datesForWeek.map((date) => {
            const value = getIsPerDiemByDate(perdiems, date);
            return (
              <OutlinedCheckBox
                key={date}
                value={value}
                onChange={() => changePerdiem(date, !value)}
                disabled={(date.month() !== choosedMonth && timesheetType === submissionEnum.MONTHLY) || fullDisabled}
              />
            );
          })}
        </div>
      ) : (
        <div className={classes.outerWrapper}>
          <div
            className={`${classes.divider} ${
              timesheetType === submissionEnum.MONTHLY ? classes.left : classes.leftSemiMonthly
            }`}
          />
          <div
            ref={refPerDiem}
            className={`${
              timesheetType === submissionEnum.MONTHLY ? classes.auxWrapper : classes.auxWrapperSemiMonthly
            }`}
          >
            <div className={classes.monthlyContainer}>
              {perdiems
                .filter((item) => dayjs(item.Date).month() === choosedMonth)
                .map((perDiemItem) => (
                  <OutlinedCheckBox
                    key={perDiemItem.Date}
                    value={perDiemItem.IsPerDiem}
                    onChange={() => changePerdiem(perDiemItem.Date, !perDiemItem.IsPerDiem)}
                    disabled={
                      (dayjs(perDiemItem.Date).month() !== choosedMonth && timesheetType === submissionEnum.MONTHLY) ||
                      fullDisabled
                    }
                  />
                ))}
            </div>
          </div>
          <div className={`${classes.divider} ${classes.right}`} />
          <p>{perdiems.reduce((count, pd) => (pd.IsPerDiem ? count + 1 : count), 0)}</p>
        </div>
      )}
    </ExpandedPanel>
  );
};

export default PerDiemCreationComponent;
